import axios from 'axios';

export const hasDeviceNotificationPermissions = (contact, portal, permissions) => { // int, string, array  => boolean
    const devicePreferences = JSON.parse( localStorage.getItem(`preferences`) || "{}" );

    if ( Boolean(devicePreferences?.[contact]?.[portal]?.['notifications']) === false ) return false;

    let checker = (arr, target) => target.every(v => arr.includes(v));
    if ( checker(devicePreferences?.[contact]?.[portal]?.['notifications'], permissions) === false ) return false;

    return true;
}

export const fetchAndSetDevicePreferences = (deviceToken, contact, portal) => {
    const url = localStorage.getItem('url');
    const token = localStorage.getItem('token');

    axios.post( `${url}api/device-preferences`, { device_token: deviceToken, contact, portal }, { headers: { Authorization: `Bearer ${token}` }} )
        .then((res) => {
            if (res.data.error) throw new Error(res.data.message);
            return res.data.preferences;
        })
        .then((preferences)=>{
            let devicePreferences = JSON.parse( localStorage.getItem(`preferences`) || "{}" );
            devicePreferences = { ...devicePreferences, [contact]: {...(devicePreferences?.[contact] || {}), [portal]: preferences} };
            devicePreferences[contact][portal] = preferences;
            localStorage.setItem('preferences', JSON.stringify(devicePreferences));
        })
        .catch(e => {console.error(e); alert("Something went wrong on fetching preferences");})
    
}